import React from 'react';

type TagProps = {
  text: string;
  icon?: React.ComponentType<{ className?: string }>;
};

export const TechnologyMissionAssessmentTagComponent: React.FC<TagProps> = (props) => {
  const { text, icon: Icon } = props;

  return (
    <div className="flex gap-1.5 items-center text-sm text-[#1F1C1AE5] font-normal bg-[#C0C0C033] rounded-sm px-2 py-1">
      {Icon && <Icon className="w-4 h-4" />}
      {text}
    </div>
  );
};
